import SiteNavbar from "@/components/SiteNavbar";
import { SiLine, SiFacebook } from "react-icons/si";
import { MapPin, Phone } from "lucide-react";

const NEW_LOGO = "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/ENZO%202026%20Logo%20RGB%20Trans-01_50a56c58d8b844dbbd7924c8c679b113.png";

const sections = [
  {
    id: "dwd-distributor",
    icon: "🏎️",
    title: "ตัวแทนจำหน่าย DWD Coilover อย่างเป็นทางการ",
    content: `เราคือ DWD Official Distributor ผู้แทนจำหน่ายโช้คอัพ DWD (DWD THAILAND) อย่างเป็นทางการในประเทศไทย ผู้เชี่ยวชาญด้านโช้คอัพปรับเกลียว (Coilover) สำหรับทุกประเภทรถยนต์ ไม่ว่าจะเป็นรถยนต์ไฟฟ้า (EV) รถยนต์ทั่วไป และรถแข่ง เรามีโช้คอัพ DWD ทุกซีรีส์ ตั้งแต่ DD-S+ สำหรับใช้งานบนถนน ไปจนถึง DD-R+ สำหรับสนามแข่ง`,
    keywords: ["DWD Thailand", "DWD Coilover", "Coilover Thailand", "โช้คอัพปรับเกลียว", "DD-Series"],
  },
  {
    id: "ev-upgrade",
    icon: "⚡",
    title: "อัพเกรดช่วงล่างรถไฟฟ้า — แก้เมา แก้เวียนหัว",
    content: `สำหรับเจ้าของรถไฟฟ้า (EV) ที่ประสบปัญหาเมารถ เวียนหัว หรือรู้สึกว่ารถโยนไม่มั่นคง เราเชี่ยวชาญการ อัพเกรดช่วงล่างรถไฟฟ้า โดยเฉพาะ การเปลี่ยนโช้คอัพรถไฟฟ้า การติดตั้งโช้คสตรัทปรับเกลียว และการ Tune ช่วงล่างให้เหมาะสมกับรถแต่ละรุ่น ช่วยแก้ปัญหา แก้เมารถไฟฟ้า และ แก้เวียนหัวรถไฟฟ้า ได้อย่างตรงจุด`,
    keywords: ["โช้คแต่งรถไฟฟ้า", "อัพเกรดช่วงล่างรถไฟฟ้า", "โช้คสตรัทปรับเกลียว", "แก้เมารถไฟฟ้า", "แก้เวียนหัวรถไฟฟ้า"],
  },
  {
    id: "motorsport",
    icon: "🏆",
    title: "อุปกรณ์มอเตอร์สปอร์ตครบวงจร",
    content: `นอกจากโช้คอัพแล้ว เรายังจำหน่ายอุปกรณ์มอเตอร์สปอร์ตครบชุด ได้แก่ หมวกกันน็อค เบาะแข่ง ถุงมือแข่ง รองเท้าแข่ง ชุดแข่ง ที่ผ่านมาตรฐาน FIA ของแท้จากแบรนด์ระดับโลก เช่น Sabelt, OMP, Bell, Alpinestars, MOMO, Brembo และอื่นๆ อีกมากมาย`,
    keywords: ["Performance Tuning", "Motorsport Equipment", "Sabelt", "OMP", "Bell", "Alpinestars", "MOMO", "Brembo"],
  },
  {
    id: "motve-runstop",
    icon: "🔧",
    title: "ตัวแทนเบรก MOTVE และ RUNSTOP",
    content: `เราเป็นตัวแทนจำหน่าย MOTVE Brake และ RUNSTOP อย่างเป็นทางการในประเทศไทย ระบบเบรกสมรรถนะสูงสำหรับทั้งรถยนต์บนถนนและสนามแข่ง พร้อม คาลิปเปอร์เบรก 6 ลูกสูบ จานเบรก และผ้าเบรกแข่ง คุณภาพระดับนานาชาติ`,
    keywords: ["MOTVE Brake", "RUNSTOP", "ร้านแต่งรถประชาอุทิศ"],
  },
];

const keywordTags = [
  "โช้คอัพ", "โช้คแต่งรถไฟฟ้า", "อัพเกรดช่วงล่างรถไฟฟ้า", "โช้คสตรัทปรับเกลียว",
  "แก้เมารถไฟฟ้า", "แก้เวียนหัวรถไฟฟ้า", "DWD Thailand", "DWD Coilover",
  "MOTVE Brake", "Performance Tuning", "Motorsport Equipment", "Sabelt",
  "OMP", "Bell", "Alpinestars", "MOMO", "Brembo", "RUNSTOP", "ร้านแต่งรถประชาอุทิศ",
];

const Index = () => {
  return (
    <div style={{ background: "#0D0D0D", minHeight: "100vh", fontFamily: "Rajdhani, sans-serif" }}>
      <SiteNavbar currentPage="/#/about" />

      {/* Hero */}
      <section
        style={{
          background: "linear-gradient(135deg, #0D0D0D 0%, #1a0a0a 100%)",
          paddingTop: "120px",
          paddingBottom: "60px",
          textAlign: "center",
          borderBottom: "1px solid rgba(232,33,42,0.2)",
        }}
      >
        <div className="container mx-auto px-4">
          <div style={{ display: "flex", justifyContent: "center", marginBottom: "28px" }}>
            <img src={NEW_LOGO} alt="ENZO Performante Store Logo" style={{ height: "72px", objectFit: "contain" }} />
          </div>
          <p
            style={{
              color: "#E8212A",
              fontSize: "13px",
              letterSpacing: "0.3em",
              textTransform: "uppercase",
              fontWeight: 700,
              marginBottom: "16px",
              fontFamily: "Rajdhani, sans-serif",
            }}
          >
            DWD Thailand x ENZO Performante Store
          </p>
          <h1
            style={{
              fontFamily: "Rajdhani, sans-serif",
              fontSize: "clamp(32px, 6vw, 72px)",
              fontWeight: 700,
              color: "#fff",
              lineHeight: 1.05,
              marginBottom: "20px",
            }}
          >
            เกี่ยวกับ<span style={{ color: "#E8212A" }}>เรา</span>
          </h1>
          <p
            style={{
              fontFamily: "Sarabun, sans-serif",
              fontSize: "clamp(15px, 2.5vw, 20px)",
              color: "rgba(255,255,255,0.7)",
              maxWidth: "640px",
              margin: "0 auto",
              lineHeight: 1.8,
            }}
          >
            จุดหมายปลายทางของการอัพเกรดสมรรถนะรถยนต์ครบวงจร
            ร้านแต่งรถประชาอุทิศ ตัวแทนจำหน่าย DWD Coilover และ MOTVE Brake อย่างเป็นทางการ
          </p>
        </div>
      </section>

      {/* About Sections */}
      <section style={{ padding: "80px 0" }}>
        <div className="container mx-auto px-4">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "40px",
              maxWidth: "860px",
              margin: "0 auto",
            }}
          >
            {sections.map((s) => (
              <div
                key={s.id}
                id={s.id}
                style={{
                  background: "#161616",
                  border: "1px solid rgba(255,255,255,0.07)",
                  borderLeft: "4px solid #E8212A",
                  borderRadius: "4px",
                  padding: "32px",
                }}
              >
                <div style={{ display: "flex", alignItems: "flex-start", gap: "16px" }}>
                  <span style={{ fontSize: "32px", flexShrink: 0, marginTop: "2px" }}>{s.icon}</span>
                  <div style={{ flex: 1 }}>
                    <h2
                      style={{
                        fontFamily: "Rajdhani, sans-serif",
                        fontSize: "clamp(20px, 3vw, 28px)",
                        fontWeight: 700,
                        color: "#fff",
                        lineHeight: 1.2,
                        marginBottom: "16px",
                      }}
                    >
                      {s.title}
                    </h2>
                    <p
                      style={{
                        fontFamily: "Sarabun, sans-serif",
                        fontSize: "16px",
                        color: "rgba(255,255,255,0.72)",
                        lineHeight: 1.9,
                        marginBottom: "20px",
                      }}
                    >
                      {s.content}
                    </p>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                      {s.keywords.map((kw) => (
                        <span
                          key={kw}
                          style={{
                            padding: "4px 10px",
                            background: "rgba(232,33,42,0.1)",
                            border: "1px solid rgba(232,33,42,0.25)",
                            color: "#E8212A",
                            fontSize: "11px",
                            fontFamily: "Rajdhani, sans-serif",
                            fontWeight: 700,
                            letterSpacing: "0.05em",
                            borderRadius: "2px",
                          }}
                        >
                          {kw}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Keywords SEO Cloud */}
      <section
        style={{
          background: "#111",
          borderTop: "1px solid rgba(232,33,42,0.15)",
          padding: "60px 0",
        }}
      >
        <div className="container mx-auto px-4">
          <div style={{ textAlign: "center", marginBottom: "36px" }}>
            <h2
              style={{
                fontFamily: "Rajdhani, sans-serif",
                fontSize: "clamp(22px, 3.5vw, 36px)",
                fontWeight: 700,
                color: "#fff",
              }}
            >
              สินค้าและบริการ<span style={{ color: "#E8212A" }}>ทั้งหมด</span>
            </h2>
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "10px",
              maxWidth: "900px",
              margin: "0 auto",
            }}
          >
            {keywordTags.map((tag) => (
              <span
                key={tag}
                style={{
                  padding: "8px 16px",
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  color: "rgba(255,255,255,0.75)",
                  fontSize: "13px",
                  fontFamily: "Sarabun, sans-serif",
                  borderRadius: "3px",
                  transition: "background 0.2s, border-color 0.2s",
                  cursor: "default",
                }}
                onMouseEnter={(e) => {
                  const el = e.currentTarget as HTMLSpanElement;
                  el.style.background = "rgba(232,33,42,0.12)";
                  el.style.borderColor = "rgba(232,33,42,0.3)";
                }}
                onMouseLeave={(e) => {
                  const el = e.currentTarget as HTMLSpanElement;
                  el.style.background = "rgba(255,255,255,0.05)";
                  el.style.borderColor = "rgba(255,255,255,0.1)";
                }}
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* Location & Contact */}
      <section style={{ padding: "80px 0" }}>
        <div className="container mx-auto px-4">
          <div style={{ textAlign: "center", marginBottom: "48px" }}>
            <h2
              style={{
                fontFamily: "Rajdhani, sans-serif",
                fontSize: "clamp(24px, 4vw, 44px)",
                fontWeight: 700,
                color: "#fff",
              }}
            >
              มาหาเรา<span style={{ color: "#E8212A" }}>ที่ประชาอุทิศ</span>
            </h2>
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "24px",
              maxWidth: "800px",
              margin: "0 auto 48px",
            }}
          >
            {[
              {
                icon: <MapPin size={20} color="#E8212A" />,
                label: "ที่อยู่",
                value: "DWD THAILAND × ENZO Performante Store สาขาประชาอุทิศ",
                link: { href: "https://maps.app.goo.gl/xJdCGjA66nCEA8v97", text: "ดูบน Google Maps →" },
              },
              {
                icon: <Phone size={20} color="#E8212A" />,
                label: "โทรศัพท์",
                value: "086-997-8800",
                link: { href: "tel:0869978800", text: "โทรได้เลย" },
              },
            ].map((item) => (
              <div
                key={item.label}
                style={{
                  background: "#161616",
                  border: "1px solid rgba(255,255,255,0.07)",
                  borderRadius: "4px",
                  padding: "24px",
                  display: "flex",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    width: "44px",
                    height: "44px",
                    background: "rgba(232,33,42,0.12)",
                    border: "1px solid rgba(232,33,42,0.3)",
                    borderRadius: "3px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {item.icon}
                </div>
                <div>
                  <p
                    style={{
                      fontFamily: "Rajdhani, sans-serif",
                      fontSize: "12px",
                      fontWeight: 700,
                      color: "rgba(255,255,255,0.4)",
                      letterSpacing: "0.15em",
                      textTransform: "uppercase",
                      marginBottom: "4px",
                    }}
                  >
                    {item.label}
                  </p>
                  <p
                    style={{
                      fontFamily: "Sarabun, sans-serif",
                      fontSize: "15px",
                      color: "#fff",
                      marginBottom: "8px",
                      lineHeight: 1.5,
                    }}
                  >
                    {item.value}
                  </p>
                  <a
                    href={item.link.href}
                    target={item.link.href.startsWith("http") ? "_blank" : undefined}
                    rel={item.link.href.startsWith("http") ? "noopener noreferrer" : undefined}
                    style={{
                      fontFamily: "Rajdhani, sans-serif",
                      fontSize: "13px",
                      fontWeight: 700,
                      color: "#E8212A",
                      textDecoration: "none",
                      letterSpacing: "0.05em",
                    }}
                  >
                    {item.link.text}
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* Contact CTA */}
          <div style={{ display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap" }}>
            <a
              href="https://lin.ee/usuFQKq"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                padding: "14px 36px",
                background: "#06C755",
                color: "#fff",
                textDecoration: "none",
                fontFamily: "Rajdhani, sans-serif",
                fontWeight: 700,
                fontSize: "16px",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                borderRadius: "3px",
              }}
            >
              <SiLine size={20} /> LINE @638lkjit
            </a>
            <a
              href="https://www.facebook.com/EnzoPerformanteStore/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                padding: "14px 36px",
                background: "#1877F2",
                color: "#fff",
                textDecoration: "none",
                fontFamily: "Rajdhani, sans-serif",
                fontWeight: 700,
                fontSize: "16px",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                borderRadius: "3px",
              }}
            >
              <SiFacebook size={20} /> Facebook
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Index;
